import axios from 'axios';
// import util from '@/util/util'
import store from '@/store/index'

const Axios = axios.create({
    // baseURL,
    timeout: 30000,
    responseType: 'json',
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
        // "Content-Type": "application/x-www-form-urlencoded"
    }
});

var layerIdx;
var layerConfig = true;

function setSpaceToNull(obj) {
    if (['boolean', 'string', 'number'].indexOf(typeof obj) > -1) {
        return obj;
    } else if (typeof obj == 'undefined') {
        return "";
    } else if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
            obj[i] = setSpaceToNull(obj[i])
        }
        return obj;
    } else if (typeof obj == 'object') {
        for (var key in obj) {
            if (typeof obj[key] == 'object') {
                obj[key] = setSpaceToNull(obj[key]);
            } else {
                obj[key] = obj[key] !== '' ? obj[key] : null;
            }
        }
    }

    return obj;
}

// 请求前置拦截器
Axios.interceptors.request.use(
    config => {
        //如果是空字符串,传null
        // config.data = setSpaceToNull(config.data)
        config.headers.Authorization = `Bearer ${store.state.user.token}` || ""
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 返回响应拦截器
Axios.interceptors.response.use(
    res => {
        if (res.status === 200) {
            return res.data;
        }
        return res;
    },
    error => {
        if (error.response.status == 401) { //登录信息失效
            // util.cookies.removeToken()
            window.location.href = window.location.href.replace(/#.*/, '#/login')
        }
        return {
            error
        };
    }
);

const request = (url, data = {}, method = 'post', layerFlag = true) => {
    return new Promise((resolve, reject) => {
        Axios({
            method,
            url: url,
            data,
        }).then(res => {
            if (res.Code == 0) {
                resolve(res.Datas)
            } else if (res.Code == 401) {
                // util.cookies.removeToken()
                // store
                window.location.href = window.location.href.replace(/#.*/, '#/login');
            } else {
                reject(res)
            }
        }).catch(error => {
            reject(error)
        })
    });
};

export default request;
